import React, { useState, useEffect, useMemo } from "react";
import { Box, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useApolloClient } from "@apollo/client";
import { GET_CONTACT_BY_PERSONAL_ID } from "./QueryPersonal";
import LoopIcon from '@mui/icons-material/Loop';

const ViewContact = ({ id, params }) => {
  const { setAlertCustom, alertCustom, handleCloseModal } = params;
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [contactFicha, setcontactFicha] = useState(null);
  useEffect(() => {
    const getcontactFicha = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_CONTACT_BY_PERSONAL_ID,
          variables: {
            getContactByPersonalIdId: id,
          },
          fetchPolicy: "network-only",
        });  
        setcontactFicha(data.getContactByPersonalId);
        setvisibility(true);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    getcontactFicha(id);
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        {" "}
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">NOMBRE</label>
            <TextField
              disabled
              value={contactFicha?.name }
            />
          </Box>
          <Box sx={style}>
            <label for="my-input">APELLIDO</label>
            <TextField disabled value={contactFicha?.surname} />
          </Box>
          <Box sx={style}>
            <label for="my-input">PARENTESCO</label>
            <TextField disabled value={contactFicha?.relation.description} />
          </Box>
          <Box sx={style}>
            <label for="my-input">TELEFONO</label>
            <TextField disabled value={contactFicha?.phone} />
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={handleCloseModal}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
}

export default ViewContact